// extracted by mini-css-extract-plugin
export var deleteIcon = "_t5-5";
export var deleteOption = "_t5-3";
export var divider = "_t5-2";
export var downloadIcon = "_t5-4";
export var drawer = "_t5-0";
export var drawerFooter = "_t5-6";
export var drawerOpen = "_t5-1";
export var highlighted = "_t5-7";
export var lighterHighlight = "_t5-8";